module.exports = "<div class=admin-fax-search><div kt-admin-fax-search></div><ui-view></ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-fax/admin-fax.html
// module id = 660
// module chunks = 0